// extracted by mini-css-extract-plugin
export default {"root":"RangeSlider_root__2cIvm","activeHandle":"RangeSlider_activeHandle__1JUQM"};